import { getIcon } from '../../lib/icons';
import { motion } from 'framer-motion';

interface ValueCardProps {
  title: string;
  description: string;
  icon: string;
  index: number;
}

export default function ValueCard({
  title,
  description,
  icon,
  index,
}: ValueCardProps) {
  const IconComponent = getIcon(icon);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
      className="p-6 bg-white rounded-2xl border border-charcoal-100 hover:shadow-lg transition-shadow"
    >
      <div className="p-3 bg-primary-50 rounded-xl w-fit mb-4">
        <IconComponent className="w-6 h-6 text-primary-600" />
      </div>
      <h3 className="font-semibold text-lg text-charcoal-900 mb-2">{title}</h3>
      <p className="text-charcoal-600 text-sm leading-relaxed">{description}</p>
    </motion.div>
  );
}
